import Vue from 'vue'
import VueAnalytics from 'vue-analytics'
import ElementUI from 'element-ui'
import VueAxios from 'vue-axios'
import axios from 'axios'
import 'element-ui/lib/theme-chalk/index.css'
import 'element-ui/lib/theme-chalk/display.css'
import locale from 'element-ui/lib/locale/lang/en'
import './sass/Index.scss'
import App from './App'
import Platform from './Platform'
import router from './router'
import { cleanDate, nairaSign } from './utils/filters'
import { getEnv } from './utils'
import './sass/element-variables.scss'

Vue.config.productionTip = false
Vue.use(ElementUI, { locale })
Vue.use(VueAxios, axios)
Vue.use(VueAnalytics, {
  id: 'UA-147074923-1',
  checkDuplicatedScript: true,
  debug: {
    sendHitTask: getEnv() === 'live',
    enabled: false
  },
  autoTracking: {
    exception: true,
    exceptionLogs: false
  },
  router
})

Vue.filter('cleanDate', cleanDate)
Vue.filter('nairaSign', nairaSign)

Vue.component('platform', Platform)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js